export const FEATURE_FLAG = {
  OPERATIONS: true,
  OPERATIONS_STOCK_TYPE_SERVICE: true,
  OPERATIONS_PURCHASE_ORDER: true,
  /**
   * Automatically refresh calendar data nad notifications?
   * Currently this should only be used for testing purposes
   */
  AUTO_REFRESH_DATA: true, // TODO: Remove feature flag

  /**
   * @see https://gitlab.dev.innovation-agents.de/ia/pro-musik/organisation/-/issues/295
   */
  SEND_COPY_TO_ME: true,

  /**
   * @see https://gitlab.dev.innovation-agents.de/ia/pro-musik/organisation/-/issues/71
   */
  SHOW_NOTE_UPDATE_MULTIPLE_ALLOCATIONS: true,

  /**
   * Display checkbox to send copy-to-me on a per request basis
   */
  SEND_COPY_TO_ME_PER_REQUEST: false,
}

console.table(FEATURE_FLAG)
